module.exports = __webpack_public_path__ + "img/Steor-Icons-11.4b5fd1d7.svg";